export const svgDemoZooLogo = (
  <svg
    className="svg-inline--fa"
    style={{
      marginTop: "0",
      marginLeft: "0",
      marginRight: "0",
      width: "24px",
      height: "18px",
      verticalAlign: "middle"
    }}
    viewBox="0 0 100 100">
    <rect x="5" y="5" width="90" height="90" rx="16" ry="16" fill="#C32E3B" />
    <text
      x="50"
      y="67"
      fill="#ffffff"
      fontFamily="system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif"
      fontWeight="300"
      fontSize="54"
      textAnchor="middle"
      letterSpacing="-1">
      DZ
    </text>
  </svg>
)

export const svgDemoZooTitle = (
  <svg viewBox="0 0 200 40" xmlns="http://www.w3.org/2000/svg" style={{ height: "30px", width: "150px" }}>
    <rect x="0" y="2" width="180" height="36" rx="6" ry="6" fill="#C32E3B" />
    <text
      x="90"
      y="28"
      fill="#ffffff"
      fontFamily="system-ui, -apple-system, sans-serif"
      fontWeight="300"
      fontSize="24"
      textAnchor="middle"
      letterSpacing="2">
      DEMOZOO
    </text>
  </svg>
)
